import {Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {NavigationEnd, Router} from "@angular/router";
import { ApplicationService } from "../../../services/application.service";
import { CookieConsentComponent } from "../../cookie-consent/cookie-consent.component";
import {CookieService, CookieStatus} from "../../../services/cookie.service";
import {Store} from "@ngrx/store";
import {addToHistory} from "../../../../store/history/history.actions";
import {SsoService} from "../../../services/sso.service";
import {Subject, takeUntil} from "rxjs";


export interface Logout {
  title: "";
  question: "";
  yes: "";
  no: "";
  type: "question" | "choose"
  bottomMessage: string;
}

@Component({
  selector: "app-action-dialog",
  templateUrl: "./action-dialog.component.html",
  styleUrls: ["./action-dialog.component.scss"],
})
export class ActionDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Logout,
    private app: ApplicationService,
    private router: Router,
    private cookiService: CookieService,
    private applicationService: ApplicationService,
    private sso: SsoService,
    private store: Store
  ) {}

  private destroy$ = new Subject<void>();
  questionValue= false;
  ngOnInit() {
    this.data.type = this.data.type || "question";
    let cookieValue = this.cookiService.cookiePolicySubject.getValue();
    this.questionValue  = cookieValue != CookieStatus.NOT_EVALUATED && cookieValue == CookieStatus.ACCEPTED;
    this.cookiService.cookiePolicySubject.subscribe((value) => {
      this.questionValue = value != CookieStatus.NOT_EVALUATED && value == CookieStatus.ACCEPTED;

    });
  }

  loggedOut() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getLink(): string {
    return `/assets/policy/policy.html?lang=${this.applicationService.getCurrentLanguage()}`;
  }

  logoutUser() {
    this.store.dispatch(addToHistory({ page: window.location.origin + "logout" }));
    this.cookiService.cookiePolicySubject.next(CookieStatus.NOT_EVALUATED);
    this.app.resetUser();
    localStorage.removeItem('firstBlinkink')
    this.sso.isSSO()
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
      const landing = value ? "/sso" : "/login"
      console.log("Navigating from logout to: "+landing)
      this.store.dispatch({ type: '[Global] Reset State' });
      this.loggedOut();
      if(!value) {
        window.location.reload();
        this.router.navigate([landing]);
      }
      else {
        this.router.navigate([landing],{queryParams: { status: 'logout' },queryParamsHandling: 'merge' });
      }

    }).unsubscribe();

  }

  onCheckboxChange(event: any): void {
    this.cookiService.cookiePolicySubject.next(event.checked ? CookieStatus.ACCEPTED : CookieStatus.REJECTED);
  }


}
